export enum TransactionDirectionEnum {
    Credit = 'credit',
    Debit = 'debit',
}